/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Gear(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={128.00195}
        cy={128}
        r={48}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M183.66282,65.08649a84.52233,84.52233,0,0,1,7.2522,7.2521l27.32235,3.90156a103.37019,103.37019,0,0,1,10.1637,24.56086L211.8466,122.8728s.20824,6.83942.00066,10.2547l16.561,22.07863a103.37014,103.37014,0,0,1-10.18033,24.554L190.915,183.66144s-4.689,4.98345-7.2507,7.25163l-3.90156,27.32234a103.36981,103.36981,0,0,1-24.56086,10.16371l-22.0704-16.55388a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561a103.36931,103.36931,0,0,1-24.554-10.18033l-3.90076-27.31148a84.521,84.521,0,0,1-7.2522-7.25211l-27.32234-3.90155A103.36971,103.36971,0,0,1,27.60381,155.2l16.55447-22.07178s-.20824-6.83942-.00065-10.2547l-16.561-22.07863A103.36914,103.36914,0,0,1,37.777,76.24087l27.31148-3.90076a84.521,84.521,0,0,1,7.25211-7.2522L76.2421,37.76556A103.37009,103.37009,0,0,1,100.803,27.60186l22.07039,16.55388a84.523,84.523,0,0,1,10.25609-.00007l22.07863-16.561a103.37,103.37,0,0,1,24.554,10.18033Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default Gear;
